import { Fragment, ReactNode } from 'react';
import { Link } from '@mui/material';

/**
 * Targets of the bracketed link labels in the approved NL copy
 * ("[algemene voorwaarden]", "[verwerkersovereenkomst]", "[privacyverklaring]").
 *
 * URL OPEN: Jorrit has not given the three URLs yet (PR #307, open question).
 * Do not invent them. While a URL is undefined the label renders as a link
 * label without an href, so nothing points anywhere wrong.
 */
export const INVOICE_LEGAL_URLS: { terms?: string; dpa?: string; privacy?: string } = {
  terms: undefined,
  dpa: undefined,
  privacy: undefined,
};

const PLACEHOLDER_MARKER = '[copy needs Jorrit]';

/**
 * Turns "[label]" in a locale string into link labels, in order, with the
 * given targets (first label -> first target). The placeholder marker of
 * texts without approved copy is left as plain text.
 */
export const renderBracketLinks = (text: string, targets: (string | undefined)[]): ReactNode[] => {
  let index = 0;
  return text.split(/(\[[^\]]+\])/).map((part, key) => {
    const label = /^\[(.+)\]$/.exec(part)?.[1];
    if (!label || part === PLACEHOLDER_MARKER) return <Fragment key={key}>{part}</Fragment>;
    const href = targets[index++];
    return (
      <Link key={key} href={href} {...(href ? { target: '_blank', rel: 'noopener noreferrer' } : {})} underline="always">
        {label}
      </Link>
    );
  });
};
